import { render } from "./ExtendForm.vue?vue&type=template&id=3d09c1ca"
import script from "./ExtendForm.vue?vue&type=script&lang=js"
export * from "./ExtendForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__